export const products = [
  {
    id: 1,
    name: 'Boron',
    icon: '⚗️',
    image: "images/OIP.webp",

    description: 'Minéral naturel offrant une excellente résistance au feu et aux insectes, tout en étant totalement écologique.'
  },
  {
    id: 2,
    name: 'Perlite',
    icon: '🪨',
    image: "images/R.jpeg",
    description: 'Roche volcanique expansée ultra-légère, excellent isolant thermique avec une structure microporeuse unique.'
  },
  {
    id: 3,
    name: 'Pumice',
    icon: '🌋',
    image: "images/OIP (2).webp",
    description: 'Pierre ponce volcanique naturelle, offrant isolation thermique et acoustique exceptionnelles.'
  },
  {
    id: 4,
    name: 'Résine Organique',
    icon: '🌿',
    image: "images/OIP (3).webp",
    description: 'Liant naturel d\'origine végétale assurant cohésion et durabilité sans produits chimiques.'
  },
  {
    id: 5,
    name: 'Polymères Naturels',
    icon: '🧬',
    image: "images/poudres.webp",
    description: 'Composés organiques naturels offrant flexibilité et résistance mécanique supérieure.'
  },
  {
    id: 6,
    name: 'Fibre de Coton',
    icon: '🌾',
    image: "images/OIP (4).webp",
    description: 'Fibres naturelles recyclées apportant isolation thermique et acoustique, totalement biodégradables.'
  }
]

export const keyProperties = [
  {
    id: 1,
    icon: '☀️',
    title: 'Capacité Photocatalytique',
    description: 'Destruction naturelle des polluants atmosphériques grâce à l\'action de la lumière.'
  },
  {
    id: 2,
    icon: '🧱',
    title: 'Polymères Naturels',
    description: 'Matériaux inorganiques constitués exclusivement de polymères d\'origine naturelle.'
  },
  {
    id: 3,
    icon: '🚫',
    title: 'Sans Substances Cancérigènes',
    description: 'Aucune substance nocive ou cancérigène dans la composition du produit.'
  },
  {
    id: 4,
    icon: '👃',
    title: 'Sans Odeur',
    description: 'Produit totalement inodore pour un confort optimal d\'utilisation.'
  },
  {
    id: 5,
    icon: '🛡️',
    title: 'Barrière Anti-Radon',
    description: 'Protection contre le radon, deuxième cause de cancer du poumon dans le monde.'
  },
  {
    id: 6,
    icon: '💨',
    title: 'Hautement Respirant',
    description: 'Matériaux permettant une excellente circulation de l\'air et régulation de l\'humidité.'
  },
  {
    id: 7,
    icon: '🐛',
    title: 'Résistance aux Insectes',
    description: 'Ne peut pas nuire aux insectes mais ne peut pas non plus être détruit par eux.'
  },
  {
    id: 8,
    icon: '📡',
    title: 'Absorption des Ondes',
    description: 'Capacité d\'absorber les ondes magnétiques pour un environnement plus sain.'
  },
  {
    id: 9,
    icon: '🌫️',
    title: 'Capture des NOx',
    description: 'Absorption et neutralisation des oxydes d\'azote polluants atmosphériques.'
  }
]

export const technicalSpecs = [
  {
    id: 1,
    icon: 'thermal',
    title: 'Isolation Thermique',
    value: '0.045 W/mk',
    details: [
      'Super isolant thermique',
      'Non affecté par le rayonnement solaire',
      'Aucun pont thermique',
      'Réflecteur pour toitures et fermes photovoltaïques',
      'Économie jusqu\'à 60% d\'énergie'
    ]
  },
  {
    id: 2,
    icon: 'sound',
    title: 'Absorption Sonore',
    value: 'aw=0.35(H)',
    details: [
      'Excellente isolation acoustique',
      'Épaisseur 12mm',
      'Réduction significative du bruit',
      'Confort acoustique optimal'
    ]
  },
  {
    id: 3,
    icon: 'fire',
    title: 'Résistance au Feu',
    value: 'Classement A2',
    details: [
      'Non combustible',
      'Résistant au feu et aux hautes températures',
      'Aucun dégagement de gaz en cas d\'incendie',
      'Sécurité maximale'
    ]
  },
  {
    id: 4,
    icon: 'adhesion',
    title: 'Haute Adhésion',
    value: '0.33 N/mm²',
    details: [
      'Adhère à tous types de surfaces',
      'Compatible avec toutes les peintures',
      'Longue durée de vie',
      'Protection contre les impacts',
      'Résistant aux acides et pluies acides'
    ]
  }
]

export const applicationSteps = [
  {
    id: 1,
    step: '01',
    phase: 'Préparation',
    title: 'Préparation du Mélange',
    description: 'Mélanger le produit ECOTHERM avec un malaxeur entre 700 et 900 RPM ou dans une bétonnière pour grandes quantités.',
    details: [
      'Utiliser un malaxeur professionnel',
      'Vitesse de rotation: 700-900 RPM',
      'Pour grandes surfaces: utiliser une bétonnière',
      'IMPORTANT: Ne jamais ajouter d\'eau'
    ],
    drying: null
  },
  {
    id: 2,
    step: '02',
    phase: 'Première Couche',
    title: 'Application de la Première Couche',
    description: 'Appliquer directement sur surface sèche et propre avec une épaisseur de 3-5mm.',
    details: [
      'Surface doit être sèche et propre',
      'Utiliser une truelle en acier inoxydable',
      'Épaisseur: 3-5mm',
      'Application manuelle ou machine à projeter'
    ],
    drying: '24-72 heures selon température'
  },
  {
    id: 3,
    step: '03',
    phase: 'Deuxième Couche',
    title: 'Application de la Deuxième Couche',
    description: 'Une fois la première couche complètement sèche, appliquer une seconde couche de 5mm.',
    details: [
      'Attendre séchage complet de la première couche',
      'Épaisseur: 5mm',
      'Pour finition lisse: utiliser truelle de lissage',
      'Possibilité d\'appliquer une troisième couche pour isolation maximale'
    ],
    drying: '24-72 heures selon température'
  },
  {
    id: 4,
    step: '04',
    phase: 'Finition',
    title: 'Finition et Revêtement',
    description: 'Après séchage complet, appliquer le revêtement mural de votre choix.',
    details: [
      'Compatible avec tous types de peintures',
      'Peintures à base d\'eau ou cellulosiques',
      'Finition lisse équivalente à un enduit conventionnel',
      'Prêt pour décoration finale'
    ],
    drying: null
  }
]

export const industries = [
  {
    id: 1,
    name: 'Secteur du Bâtiment',
    icon: '🏗️',
    description: 'Le secteur de la construction fait face à de nombreux enjeux liés à l\'environnement, la sécurité publique et l\'aménagement du territoire. ECOTHERM répond parfaitement aux exigences du bâtiment durable.',
    benefits: [
      'Annulation de la consommation d\'eau',
      'Limitation des émissions de CO2',
      'Matériaux perspirables et réfractaires',
      'Isolation thermique et acoustique inégalée',
      'Conformité aux normes de construction durable'
    ]
  },
  {
    id: 2,
    name: 'Industries Sensibles',
    icon: '⚙️',
    description: 'Le risque industriel est classé comme risque technologique majeur. ECOTHERM protège les infrastructures critiques en réduisant leur vulnérabilité.',
    benefits: [
      'Protection contre les incendies',
      'Résistance aux explosions',
      'Prévention de la pollution',
      'Continuité de l\'activité assurée',
      'Sécurité des installations'
    ]
  },
  {
    id: 3,
    name: 'Secteur de la Santé',
    icon: '🏥',
    description: 'Le secteur de la santé nécessite une protection stricte contre les risques sanitaires. ECOTHERM participe activement à la désinfection et décontamination radioactive.',
    benefits: [
      'Assainissement des locaux',
      'Désinfection active',
      'Décontamination radioactive',
      'Protection contre les pathogènes',
      'Environnement sain pour patients et personnel'
    ]
  },
  {
    id: 4,
    name: 'Industries de Sécurité',
    icon: '🛡️',
    description: 'L\'industrie de la défense requiert une excellence technologique constante. ECOTHERM offre les meilleures réponses technologiques pour l\'équipement du futur.',
    benefits: [
      'Excellence technologique',
      'Solutions innovantes',
      'Performance élevée',
      'Durabilité extrême',
      'Vision prospective'
    ]
  }
]